import React from 'react';

import { callApi } from 'helpers/callApi/callApi';
import AppModal from 'components/modal/appModal';
import { ArchiveEventModalContentProps } from './ArchiveEventModal.types';

export const ArchiveEventModalContent = ({
  archiveEvent,
  data: { event },
  id,
  close,
}: ArchiveEventModalContentProps) => {
  const handleSubmit = () => {
    callApi({
      action: () => archiveEvent(event.id, event.archived),
      onSuccess: close,
    });
  };

  return (
    <AppModal
      id={id}
      title="Archive event"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      {event.archived ? (
        <p>
          Are you sure you want to unarchive <strong>{event.name || 'unnamed'}</strong> event?
        </p>
      ) : (
        <p>
          Are you sure you want to archive <strong>{event.name || 'unnamed'}</strong> event?
        </p>
      )}
    </AppModal>
  );
};
